import { useState } from "react";
import "./Report.css";
import { useLocation, useNavigate } from "react-router-dom";
import { FaLongArrowAltLeft } from "react-icons/fa";
import Loading from "../Loader/Loading";
import myImage from "../../assets/183.png";
import { FaInfoCircle } from "react-icons/fa";

const Report = () => {
  const [filterdata, setfilterdata] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filters, setfilters] = useState({
    clientName: "",
    support: "",
    users: "",
    startdate: "",
    enddate: "",
    status: "",
  });
  const [submittedFilters, setSubmittedFilters] = useState(null);
  const [isOpenSupport, setIsOpenSupport] = useState(false);
  const [searchTermSupport, setSearchTermSupport] = useState("");
  const [dateError, setDateError] = useState("");
  const [showclosedOptions, setShowclosedOptions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const { clientlist = [], users = [] } = location.state || {};
  const [isreportopen, setisreportopen] = useState(false);
  const [currentPageClosed, setCurrentPageClosed] = useState(1);
  const rowsPerPage = 10;

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const Navigate = useNavigate();

  const filteredTickets = filterdata.filter((ticket) => {
    return userDetails.role === "cmanager"
      ? ticket.client_id?.toString() === userDetails.clientid?.toString()
      : true;
  });

  const totalPagesClosed = Math.ceil(filteredTickets.length / rowsPerPage);
  const startIndexClosed = (currentPageClosed - 1) * rowsPerPage;
  const currentRowsClosed = filteredTickets.slice(
    startIndexClosed,
    startIndexClosed + rowsPerPage
  );

  const labelMap = {
    clientName: "Client Name",
    support: "Support Team",
    users: "Users",
    startdate: "Start Date",
    enddate: "End Date",
  };

  const handlehomepage = () => {
    Navigate("/CM");
  };

  const handleSubmit = () => {
    // Validate date range
    if (filters.startdate || filters.enddate) {
      if (!filters.startdate || !filters.enddate) {
        setDateError("Both start date and end date must be selected.");
        return;
      }

      if (new Date(filters.startdate) > new Date(filters.enddate)) {
        setDateError("Start date must be earlier than end date.");
        return;
      }

      setDateError("");
    } else {
      setDateError("");
    }

    handleFilterData();
  };

  const handleFilterData = async () => {
    if (
      filters.clientName ||
      filters.support ||
      filters.users ||
      filters.status ||
      (filters.startdate && filters.enddate)
    ) {
      setIsLoading(true);
      setisreportopen(true);
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/report.php`;
      const formData = new FormData();

      formData.append("client_name", filters.clientName?.label || "");
      formData.append("assignedto_id", filters.support?.id || "");
      formData.append("id", filters.users?.id || "");
      formData.append("start_date", filters.startdate || "");
      formData.append("end_date", filters.enddate || "");
      formData.append("status", filters?.status);
      formData.append("subs", userDetails?.sub);

      try {
        setfilterdata([]);
        const response = await fetch(apiUrl, {
          method: "POST",
          body: formData,
        });
        const data = await response.json();
        setSubmittedFilters(filters);
        if (data.data) {
          // setSubmittedFilters(filters);

          setfilterdata(data.data);
        } else {
          setfilterdata([]);
        }
      } catch (error) {
        console.log("Error with POST request:", error);
        setfilterdata([]);
      } finally {
        setIsLoading(false);
      }
    } else {
      alert("Please enter all the required fields");
    }
  };

  const handleRemoveFilter = (keyToRemove) => {
    const updatedFilters = { ...filters, [keyToRemove]: "" };
    if (keyToRemove === "startdate" || keyToRemove === "enddate") {
      updatedFilters.startdate = "";
      updatedFilters.enddate = "";
    }
    setfilters(updatedFilters);
    setSubmittedFilters(updatedFilters);
  };

  const handleSupportSelect = (selectedItem) => {
    setfilters((prevFilters) => ({
      ...prevFilters,
      clientName: { id: selectedItem.id, label: selectedItem.client_code },
    }));
    setIsOpenSupport(false);
    setSearchTermSupport("");
  };

  const handleUserSelect = (selectedItem, type) => {
    if (!selectedItem) return; // ✅ skip if invalid

    setfilters((prevFilters) => ({
      ...prevFilters,
      [type]: { id: selectedItem.id, label: selectedItem.user_name },
    }));
  };

  const handlereportclosed = async (type) => {
    if (
      !filters.clientName?.label ||
      !filters.support?.id ||
      !filters.users?.id ||
      !filters.startdate ||
      !filters.enddate ||
      !filters.status
    ) {
      // Extract and encode values
      const userId = encodeURIComponent(filters.users.id || "");
      const supportId = encodeURIComponent(filters.support.id || "");

      const clientId = encodeURIComponent(filters.clientName.label || "");
      const startDate = encodeURIComponent(filters.startdate || "");
      const endDate = encodeURIComponent(filters.enddate || "");
      const subs = encodeURIComponent(userDetails?.sub || "");
      const fileType = type === "pdf" ? "pdf" : "csv";
      const status = encodeURIComponent(filters.status || "");

      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/report_download.php?subs=${subs}&id=${userId}&assignedto_id=${supportId}&client_name=${clientId}&start_date=${startDate}&end_date=${endDate}&status=${status}&type=${fileType}`;

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
        });

        const contentType = response.headers.get("Content-Type");

        if (!response.ok || !contentType.includes(fileType)) {
          const text = await response.text();
          console.error("Unexpected response:", text);
          return;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `report-${filters.startdate}-${filters.enddate}.${fileType}`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Download error:", error);
        alert("There was an error downloading the report.");
      }
    }
  };

  const filteredSupportOptions = clientlist.filter((item) =>
    item.client_code.toLowerCase().includes(searchTermSupport.toLowerCase())
  );

  const handleViewClick = (row) => {
    setSelectedRow(row);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedRow(null);
  };

  return (
    <>
      <div className="align">
        <button className="button" onClick={handlehomepage}>
          <svg>
            <FaLongArrowAltLeft />
          </svg>
          <div className="text">Home</div>
        </button>
      </div>
      <div className="report-layout">
        <div className="report-container">
          <h2 className="head">Report</h2>

          <div className="filter-section">
            {userDetails.role !== "cmanager" && userDetails.role !== "bh" && (
              <>
                {/* Client Name Dropdown */}
                <div className="date-range-group">
                  <label className="date-label">Client Name</label>
                  <div
                    className="dropdown-header"
                    onClick={() => setIsOpenSupport(!isOpenSupport)}
                  >
                    {filters.clientName?.label || "Select Client"}
                  </div>

                  {isOpenSupport && (
                    <div className="dropdown-body">
                      <input
                        type="text"
                        className="dropdown-search"
                        placeholder="Search..."
                        value={searchTermSupport}
                        onChange={(e) => setSearchTermSupport(e.target.value)}
                      />
                      {filteredSupportOptions.map((item, idx) => (
                        <div
                          key={idx}
                          className="dropdown-item"
                          onClick={() => handleSupportSelect(item)}
                        >
                          {item.client_code}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Support Team Dropdown */}
                <div className="date-range-group">
                  <label
                    // htmlFor="support"
                    className="date-label"
                  >
                    Support Team
                  </label>
                  <select
                    className="admin-portal-select"
                    value={filters.support?.id || ""}
                    // onChange={(e) =>
                    //   handleUserSelect(
                    //     users.find((u) => u.id === e.target.value),
                    //     "support"
                    //   )
                    // }

                    onChange={(e) => {
                      const selectedUser = users.find(
                        (u) => u.id === Number(e.target.value)
                      );
                      handleUserSelect(selectedUser, "support");
                    }}
                  >
                    <option value="" disabled>
                      Select Support
                    </option>
                    {users
                      .filter((user) =>
                        ["support", "admin"].some((role) =>
                          user.role.includes(role)
                        )
                      )
                      .map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.user_name}
                        </option>
                      ))}
                  </select>
                </div>
              </>
            )}

            {/* Users Dropdown */}
            <div className="date-range-group">
              <label
                //  htmlFor="users"
                className="date-label"
              >
                Users
              </label>
              <select
                className="admin-portal-select"
                value={filters.users?.id || ""}
                // onChange={(e) =>
                //   handleUserSelect(
                //     users.find((u) => u.id === e.target.value),
                //     "users"
                //   )
                // }
                onChange={(e) =>
                  handleUserSelect(
                    users.find((u) => u.id === Number(e.target.value)), // Convert to number
                    "users"
                  )
                }
              >
                <option value="" disabled>
                  Select Users
                </option>
                {users
                  .filter((user) => {
                    if (user.role === "admin") return false; // Only show users with role "user"

                    const selectedClientId = filters.clientName?.id?.toString();
                    const userClientId = user.client_id?.toString();
                    const currentUserClientId =
                      userDetails.clientid?.toString();

                    if (selectedClientId) {
                      return userClientId === selectedClientId;
                    } else {
                      if (userDetails.role !== "cmanager") {
                        return true; // Admin sees all users
                      } else if (userDetails.role === "cmanager") {
                        return userClientId === currentUserClientId; // Manager sees only users from their company
                      } else {
                        return false;
                      }
                    }
                  })
                  .map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.user_name}
                    </option>
                  ))}
              </select>
            </div>

            {/* Date Filters */}
            <div className="date-range-group">
              <label
                //  htmlFor="startDate"
                className="date-label"
              >
                From
              </label>
              <input
                type="date"
                className="datePicker"
                name="startDate"
                id="startDate"
                value={filters.startdate}
                onChange={(e) =>
                  setfilters((prevFilters) => ({
                    ...prevFilters,
                    startdate: e.target.value,
                  }))
                }
              />
            </div>

            <div className="date-range-group">
              <label
                //  htmlFor="endDate"
                className="date-label"
              >
                To
              </label>
              <input
                type="date"
                className="datePicker"
                name="endDate"
                id="endDate"
                value={filters.enddate}
                onChange={(e) =>
                  setfilters((prevFilters) => ({
                    ...prevFilters,
                    enddate: e.target.value,
                  }))
                }
              />
            </div>

            {/* status  */}
            <div className="date-range-group">
              <label className="date-label">Status</label>
              <select
                className="admin-portal-select"
                value={filters.status}
                onChange={(e) =>
                  setfilters((prev) => ({ ...prev, status: e.target.value }))
                }
              >
                <option value="">All Status</option>
                <option value="Approval Pending">Approval Pending</option>
                <option value="Un Assigned">Un Assigned</option>
                <option value="Assigned">Assigned</option>
                <option value="Hold">Hold</option>
                <option value="Closed">Closed</option>
                <option value="Dismissed">Dismissed</option>
              </select>
            </div>

            {dateError && <div className="error-message">{dateError}</div>}
          </div>

          <div className="download-buttons">
            <div className="btn-submit-outer">
              <button
                className="btn-submit"
                // onClick={() => (handleSubmit(), setisreportopen(true))}
                onClick={handleSubmit}
              >
                Submit
              </button>
            </div>
          </div>

          {isLoading && <Loading type="report" />}
          <div>
            <div>
              {submittedFilters && (
                <div className="box-filter-container">
                  <h3>Selected Filters</h3>
                  {submittedFilters ? (
                    <ul className="filter-badges">
                      {Object.entries(submittedFilters).map(([key, value]) => {
                        if (!value) return null;
                        const displayValue = value.label || value;
                        return (
                          <li key={key} className="filter-badge">
                            <div>
                              <strong>{labelMap[key] || key}:</strong>{" "}
                              {displayValue}
                            </div>
                            <button
                              className="remove-filter-btn"
                              onClick={() => handleRemoveFilter(key)}
                            >
                              &minus;
                            </button>
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    <p>No filters applied</p>
                  )}
                </div>
              )}
            </div>
            {isreportopen && (
              <>
                {filterdata.length === 0 ? (
                  <div className="images">
                    <img src={myImage} alt="Description" />
                    <div className="notickets">
                      🔍 No Tickets found for the Matching Result.
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="tickeet-summary">
                      <div className="ticket-card">
                        <span>Total Tickets:</span>
                        <span>
                          {
                            filterdata.filter((ticket) =>
                              userDetails.role === "cmanager"
                                ? ticket.client_id?.toString() ===
                                  userDetails.clientid?.toString()
                                : true
                            ).length
                          }
                        </span>
                      </div>
                      <div className="ticket-card">
                        <span>UnAssigned Tickets:</span>
                        <span>
                          {
                            filterdata.filter(
                              (ticket) =>
                                ticket.status === "Un Assigned" &&
                                (userDetails.role === "cmanager"
                                  ? ticket.client_id?.toString() ===
                                    userDetails.clientid?.toString()
                                  : true)
                            ).length
                          }
                        </span>
                      </div>
                      <div className="ticket-card">
                        <span>Assigned Tickets:</span>
                        <span>
                          {
                            filterdata.filter(
                              (ticket) =>
                                ticket.status === "Assigned" &&
                                (userDetails.role === "cmanager"
                                  ? ticket.client_id?.toString() ===
                                    userDetails.clientid?.toString()
                                  : true)
                            ).length
                          }
                        </span>
                      </div>
                      <div className="ticket-card">
                        <span>Opened Tickets:</span>
                        <span>
                          {
                            filterdata.filter(
                              (ticket) =>
                                ticket.status === "Opened" &&
                                (userDetails.role === "cmanager"
                                  ? ticket.client_id?.toString() ===
                                    userDetails.clientid?.toString()
                                  : true)
                            ).length
                          }
                        </span>
                      </div>
                      <div className="ticket-card">
                        <span>Hold Tickets:</span>
                        <span>
                          {
                            filterdata.filter(
                              (ticket) =>
                                ticket.status === "Hold" &&
                                (userDetails.role === "cmanager"
                                  ? ticket.client_id?.toString() ===
                                    userDetails.clientid?.toString()
                                  : true)
                            ).length
                          }
                        </span>
                      </div>
                      <div className="ticket-card">
                        <span>Closed Tickets:</span>
                        <span>
                          {
                            filterdata.filter((ticket) =>
                              userDetails.role === "cmanager"
                                ? ticket.client_id?.toString() ===
                                  userDetails.clientid?.toString()
                                : true
                            ).length
                          }
                        </span>
                      </div>
                    </div>

                    <div>
                      <div
                        className="download-wrapper"
                        onClick={() => setShowclosedOptions(true)}
                        onMouseLeave={() => setShowclosedOptions(false)}
                      >
                        <button className="downbtn">Download</button>
                        {showclosedOptions && (
                          <div className="download-actions">
                            <button onClick={() => handlereportclosed("pdf")}>
                              PDF
                            </button>
                            <button onClick={() => handlereportclosed("csv")}>
                              Excel
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="table-container1">
                        <table className="report-table">
                          <thead>
                            <tr>
                              <th>SI.NO</th>
                              {userDetails?.role !== "cmanager" && (
                                <th>Client Name</th>
                              )}
                              <th>User Name</th>
                              <th>Ticket Number</th>
                              <th>Error Title</th>
                              <th>Full Details</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentRowsClosed.length > 0 ? (
                              currentRowsClosed.map((item, index) => (
                                <tr key={item.id}>
                                  <td className="tdh">
                                    {startIndexClosed + index + 1}.
                                  </td>
                                  <td>{item.client_code}</td>
                                  {userDetails?.role !== "cmanager" && (
                                    <td>{item.user_name}</td>
                                  )}
                                  <td>{item.ticketnumber}</td>
                                  <td>{item.e_title}</td>
                                  {userDetails?.role !== "cmanager" && (
                                    <td>
                                      <button
                                        className="tdi"
                                        onClick={() =>
                                          handleViewClick({
                                            ticketNumber: item.ticketnumber,
                                            create: item.create_time,
                                            employeeName: item.user_name,
                                            ph: item.contactnumber,
                                            errorDescription: item.e_des,
                                            file: item.files,
                                            title: item.e_title,
                                            ticketId: item.id,
                                            status: item.status,
                                            res_time: item.res_time,
                                            asname: item.assname,
                                            remarks: item.remarks,
                                            approval1Time:
                                              item?.approved_by?.A1
                                                ?.DateAndTime,
                                            approval2Time:
                                              item?.approved_by?.A2
                                                ?.DateAndTime,
                                            a1name:
                                              item?.approved_by?.A1
                                                ?.actionbyid || "",
                                            a2name:
                                              item?.approved_by?.A2
                                                ?.actionbyid || "",
                                            a1status:
                                              item?.approved_by?.A1?.status ||
                                              "",
                                            a2status:
                                              item?.approved_by?.A2?.status ||
                                              "",
                                            unassignedTime: item.unassignedTime,
                                            time_taken: item.time_taken,
                                          })
                                        }
                                      >
                                        View
                                      </button>
                                    </td>
                                  )}
                                  <td>{item.status}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="7">No data found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      {totalPagesClosed > 1 && (
                        <div className="tdj">
                          <div>
                            <h2 className="tdk">
                              Page {currentPageClosed} of {totalPagesClosed}
                            </h2>

                            <div className="tdl">
                              {currentPageClosed !== 1 && (
                                <>
                                  <button
                                    className="tdm"
                                    onClick={() => setCurrentPageClosed(1)}
                                  >
                                    &laquo; First page
                                  </button>

                                  <button
                                    className="tdm"
                                    onClick={() =>
                                      setCurrentPageClosed((prev) =>
                                        Math.max(prev - 1, 1)
                                      )
                                    }
                                  >
                                    &lt; Previous
                                  </button>
                                </>
                              )}

                              {currentPageClosed !== totalPagesClosed && (
                                <>
                                  <button
                                    className="tdn"
                                    onClick={() =>
                                      setCurrentPageClosed((prev) =>
                                        Math.min(prev + 1, totalPagesClosed)
                                      )
                                    }
                                  >
                                    Next &gt;
                                  </button>

                                  <button
                                    className="tdo"
                                    onClick={() =>
                                      setCurrentPageClosed(totalPagesClosed)
                                    }
                                  >
                                    Last page &raquo;
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    {isModalOpen && selectedRow && (
                      <div className="tdp">
                        <div className="tdr">
                          <div className="tds-container">
                            <div className="tds">
                              <h2 className="tdt">Ticket Details</h2>
                              <div className="tinfo-container">
                                <div className="tinfo-ticket-wrapper">
                                  <p className="tinfo-ticket-number">
                                    <strong>{selectedRow.ticketNumber}</strong>
                                    <span className="tinfo-icon-wrapper">
                                      <FaInfoCircle className="tinfo-icon" />
                                      <span className="tinfo-tooltip">
                                        Ticket Created: {selectedRow.create}{" "}
                                        <br />
                                        {selectedRow.approval1Time && (
                                          <>
                                            Manager Approved Time:{" "}
                                            {selectedRow.a1name} -{" "}
                                            {selectedRow.approval1Time}
                                            <br />
                                          </>
                                        )}
                                        {selectedRow.approval2Time && (
                                          <>
                                            Business Head Approved Time:{" "}
                                            {selectedRow.a2name} -{" "}
                                            {selectedRow.approval2Time}
                                            <br />
                                          </>
                                        )}
                                        {selectedRow.unassignedTime && (
                                          <>
                                            Ticket Landed Time:{" "}
                                            {selectedRow.unassignedTime}
                                            <br />
                                          </>
                                        )}
                                        {["Hold", "Opened"].includes(
                                          selectedRow?.status
                                        ) &&
                                          `Ticket Opened: ${
                                            selectedRow.res_time ===
                                              "0000-00-00 00:00:00" ||
                                            !selectedRow.res_time
                                              ? "-"
                                              : selectedRow.res_time
                                          }`}
                                      </span>
                                    </span>
                                  </p>
                                </div>

                                {/* Employee info row */}
                                <div className="tinfo-employee-row">
                                  <p className="tinfo-field">
                                    <strong className="tinfo-label">
                                      Employee Name:
                                    </strong>
                                    <br />
                                    {selectedRow.employeeName}
                                  </p>
                                  <p className="tinfo-field">
                                    <strong className="tinfo-label">
                                      Contact Number:
                                    </strong>
                                    <br />
                                    {selectedRow.ph}
                                  </p>
                                </div>

                                <div className="tinfo-employee-row">
                                  <p className="tinfo-field">
                                    <strong className="tinfo-label">
                                      Error Title:
                                    </strong>
                                    <br />
                                    {selectedRow.title}
                                  </p>
                                  {/* <pre>{JSON.stringify(selectedRow.remarks, null, 2)}</pre> */}

                                  {/* Properly map remarks to display */}
                                  {selectedRow.remarks &&
                                    typeof selectedRow.remarks === "object" &&
                                    Object.entries(selectedRow.remarks).map(
                                      ([key, value]) => {
                                        let label =
                                          key === "A1" ? (
                                            <>
                                              Manager Remarks (
                                              {selectedRow?.a1name}) -{" "}
                                              {selectedRow?.a1status}
                                            </>
                                          ) : key === "A2" ? (
                                            <>
                                              Business Head Remarks (
                                              {selectedRow?.a2name}) -{" "}
                                              {selectedRow?.a2status}
                                            </>
                                          ) : (
                                            key
                                          );
                                        return (
                                          <p key={key} className="tinfo-field">
                                            <strong className="tinfo-label">
                                              {label}:
                                            </strong>{" "}
                                            {value}
                                          </p>
                                        );
                                      }
                                    )}
                                </div>

                                <p className="tinfo-field">
                                  <strong className="tinfo-label">
                                    Error Description:
                                  </strong>
                                  <br />
                                  {selectedRow.errorDescription}
                                </p>

                                {selectedRow.file && (
                                  <p className="tinfo-field">
                                    <strong className="tinfo-label">
                                      File:
                                    </strong>
                                    <br />
                                    <a
                                      href={`${process.env.REACT_APP_BASEURL}/apis/uploads/${selectedRow.file}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="tinfo-file-link"
                                    >
                                      {selectedRow.file}
                                    </a>
                                  </p>
                                )}

                                <div className="tinfo-employee-row">
                                  {selectedRow?.status === "Assigned" && (
                                    <p className="tinfo-field">
                                      <strong className="tinfo-label">
                                        Ticket Handled Name:
                                      </strong>
                                      <br />
                                      {selectedRow.asname}
                                    </p>
                                  )}
                                  {selectedRow?.status === "Closed" && (
                                    <p className="tinfo-field">
                                      <strong className="tinfo-label">
                                        Time Taken to Closed the Ticket:
                                      </strong>
                                      <br />
                                      {selectedRow.time_taken}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="tdq" onClick={closeModal}>
                            &times;
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Report;
